import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from "@angular/router";


@Component({
  selector: 'app-botao-home',
  standalone: true,
  imports: [],
  templateUrl: './botao-home.component.html',
  styleUrl: './botao-home.component.css'
})
export class BotaoHomeComponent {
  @Output() voltarHome:EventEmitter<void> = new EventEmitter<void>();

  constructor(private router: Router) {}

  voltarParaHome(): void {
    this.voltarHome.emit();
    this.router.navigate(['/principal']);
  }
}
